import { jsonApi } from '../client';
import type {
  AcceptTermsRequest,
  LoginRequest,
  LoginResponse,
  MsalCodeRequest,
  MsalInitResponse,
  MsalSwitchCodeRequest,
  MsalSwitchTokenRequest,
  MsalTokenRequest,
  RefreshRequest,
  RegisterRequest,
  ResetPasswordRequest,
  SendResetPasswordEmailRequest,
  SendVerifyEmailRequest,
  SsoInitiateResponse,
  SsoVerifyRequest,
  VerifyEmailRequest,
} from './types';

const auth = jsonApi('landlord/auth');

const login = (data: LoginRequest): Promise<LoginResponse> => {
  return auth.post('login', data);
};

const refresh = (data: RefreshRequest): Promise<LoginResponse> => {
  return auth.post('refresh', data);
};

const register = (data: RegisterRequest): Promise<unknown> => {
  return auth.post('register', data);
};

const sendVerifyEmail = (data: SendVerifyEmailRequest): Promise<unknown> => {
  return auth.post('send-verify-email', data);
};

const verifyEmail = (data: VerifyEmailRequest): Promise<unknown> => {
  return auth.get(`verify-email/${data.id}?expires=${data.expires}&signature=${data.signature}`);
};

const sendResetPasswordEmail = (data: SendResetPasswordEmailRequest): Promise<unknown> => {
  return auth.post('send-reset-password-email', data);
};

const resetPassword = (data: ResetPasswordRequest): Promise<unknown> => {
  return auth.post('reset-password', data);
};

const ssoVerify = (data: SsoVerifyRequest): Promise<LoginResponse> => {
  return auth.post('sso/verify', data);
};

const logout = (): Promise<unknown> => {
  return auth.post('logout');
};

const acceptTerms = async (data: AcceptTermsRequest): Promise<unknown> => {
  return auth.put('accept/terms', data);
};

const ssoInitiate = (): Promise<SsoInitiateResponse> => {
  return auth.post('sso/initiate');
};

const check = (): Promise<void> => {
  return auth.get('check');
};

const msalInit = (): Promise<MsalInitResponse> => {
  return auth.post('msal/init');
};

const msalTokenLogin = (data: MsalTokenRequest): Promise<LoginResponse> => {
  return auth.post('msal/token', data);
};

const msalCodeLogin = (data: MsalCodeRequest): Promise<LoginResponse> => {
  return auth.post('msal/code', data);
};

const msalSwitchToken = (data: MsalSwitchTokenRequest): Promise<void> => {
  return auth.post('msal/switch', data);
};

const msalSwitchCode = (data: MsalSwitchCodeRequest): Promise<void> => {
  return auth.post('msal/switch/code', data);
};

export const landlordAuthApi = {
  login,
  refresh,
  register,
  sendVerifyEmail,
  verifyEmail,
  sendResetPasswordEmail,
  resetPassword,
  ssoVerify,
  logout,
  acceptTerms,
  ssoInitiate,
  check,
  msalInit,
  msalTokenLogin,
  msalCodeLogin,
  msalSwitchToken,
  msalSwitchCode,
};
